import withTablaControl from "../../hoc/ControlCapacitaciones/withTablaControl";
import TablaControlCapacitaciones from "../../view/components/Tablas/ControlCapacitaciones/TablaControlCapacitaciones/TablaControlCapacitaciones";

export default withTablaControl(TablaControlCapacitaciones);